
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { DataGrid} from 'devextreme-react';
import { DataGridTypes} from 'devextreme-react/data-grid';
import { t } from 'i18next';
import { useCallback, useRef } from 'react'
import CustomStore from 'devextreme/data/custom_store';
import { vendorService } from '@/projects/syncflow/services/vendor_supply_parameter-service';
import { toast } from 'react-toastify';
import order_day_panel from '../components/order_day_panel';
import order_monthly_panel from '../components/order_montly_panel';
import edit_cell_time_picker from '../components/edit_cell_time_picker';
import GridToolbar from '../components/grid_tool_bar';
import VendorSupplyParameterQuery from './vendor_supply_parameter_query';
import { EditingStartEvent } from 'devextreme/ui/data_grid';
import edit_cell_render from '../components/edit_cell_render';
import DataGridWrapper from '../components/data-grid-wrapper';


var locationCode:string='0';
var locationName:string=t('syncflow:lb_all_location');

const vendorSupplyParameter = () => {
    const dataGridRef = useRef<DataGrid>(null);
    const queryRef=useRef<any>(null);
    
  const dataGridLoad=()=>{
    return vendorService.listVendorSupplyParameter(locationCode);
  }

    const mainStore = new CustomStore({
        key: ['id','vendorCode', 'locationCode'], // Composite key
        load: dataGridLoad,
        useDefaultSearch: true
    });
    const onCellPrepared = async (e: any) => {
        if (e.rowType !== 'data') return;
        if (e.data.isTemp) {
            e.cellElement.bgColor = "#F0F0F0";
        }
    };

    /*Query*/
   
    const query_changed = useCallback((location_code:any,location_name:string) => {
       locationCode=location_code;
       locationName=location_name;
    }, []);

    const checkPermission=()=>{
            return {canRemove:(locationCode!="0"),canAddNew:(locationCode!="0")}
    }
    
    const grid_render =
    {
        order_monthly_cell_render:(cell:any)=>{return order_monthly_panel(cell)},
        order_day_cell_render:(cell:any)=>{return order_day_panel(cell)},
        cuttoff_cell_render:(cell:any)=>{return edit_cell_time_picker(cell)},
        vendor_cell_render:(cell:any)=>{
            return edit_cell_render(
                {
                load:vendorService.getSuppliers,
                onChanged:(e:any)=>{                
                    cell.data.vendorCode=e.selectedItem.code;
                    cell.data.vendorName=e.selectedItem.name;
                    }
                })},
    }
      
    
     const save_grid_data = (e: DataGridTypes.SavingEvent) => {
            e.cancel = true;
             if (e.changes.length > 0) {
                        vendorService.SaveVendorSupplyParameters(e.changes).then((response) => {
                            toast.success(t("syncflow:msg_saved"));
                        });
            
                    }
        }     

       const onInitRow= async (e:any)=>{
        e.data.vendorCode=null;
        e.data.vendorName=null;
        e.data.locationCode=locationCode;
        e.data.locationName=locationName;
        e.data.cutOffTime=null,
        e.data.hasAdditionalOrder=false;
        e.data.cannotOrderAfterCutOffTime=false;
        e.data.isOrderDay01=true;
        e.data.isOrderDay02=true;
        e.data.isOrderDay03=true;
        e.data.isOrderDay04=true;
        e.data.isOrderDay05=true;
        e.data.isOrderDay06=false;
        e.data.isOrderDay07=false;
        e.data.deliveryDay01=1;
        e.data.deliveryDay02=1;
        e.data.deliveryDay03=1;
        e.data.deliveryDay04=1;
        e.data.deliveryDay05=1;
        e.data.deliveryDay06=1;
        e.data.deliveryDay07=1;
        e.data.orderPeriod="W";
        e.data.firstWeek=null;
        e.data.secondWeek=null;
        e.data.thirdWeek=null;
        e.data.fourthWeek=null;
        e.data.lastWeek=null;
        e.data.weekPeriod=null;
       };

      const onEditingStart=(e:EditingStartEvent)=>{
        
        if(  e.column?.name=='vendorName' && e.key !=undefined)
        {
            e.cancel=true;
        }
            return;
    }

 const periods = [
    { id: "W", description: t('syncflow:weekly') },
    { id: "M", description: t('syncflow:monthly') },
  ];

    return (
        <>
        <div className="card">
        <div className="card-body">
        <VendorSupplyParameterQuery onchaged={query_changed}></VendorSupplyParameterQuery> 
        </div>
        </div>
        
            <DataGridWrapper
                props={{ id: 'vendor-supply-parameter-list', ref: dataGridRef }}
                onCellPrepared={onCellPrepared}
                datasource={mainStore}
                headerFilterVisible={true}
                onEditingStart={onEditingStart}
                onSaving={save_grid_data}            
                selectionConfig={{ mode:'multiple', selectAllMode: 'allPages', showCheckBoxesMode: 'always' }}
                editingConfig={{
                    mode:'batch',
                    allowUpdating: true,
                    allowEditing: true,
                    confirmDeleteMessage: RemoveMessage('VenderSupplyParameter')
                }}
                onInitNewRow={onInitRow }
                remoteOperations={false}
                pagerVisible={true}
                onEditorPreparing={(e: any) => {
                    if (e.dataField === "orderPeriod") {
                        e.editorOptions.onValueChanged = (args: any) => {
                            const rowIndex = e.component.getRowIndexByKey(e.row?.key);
                            if (rowIndex !== -1) {
                                e.component.cellValue(rowIndex, "orderPeriod", args.value);
                                e.component.repaintRows([rowIndex]);
                            }
                        }
                    }
                }}
                customToolbarContent={ GridToolbar({gridRef:dataGridRef,canAddNew:false,canRemove:false,canChoseColumn:false,CheckPermision:checkPermission, delete_api: vendorService.deleteVendorSupplyParameter})}                    
                columns={[
                    { dataField: 'vendorCode', caption: t('syncflow:vendor_code'), visible:false },
                    { dataField: 'vendorName', caption: t('syncflow:vendor_name') , width:240,
                        allowEditing: true,
                         editCellRender:grid_render.vendor_cell_render,    },
                    { dataField: 'locationCode', caption: t('syncflow:location_code'), visible:false, },
                    { dataField: 'locationName', caption: t('syncflow:location_name'), width:240,allowEditing: false,cellRender: (data: any) => { return (<span>{data.data.locationCode== null? t('syncflow:lb_all_location'): data.data.locationName}</span>)}},
                    
                    { dataField: 'cutOffTime', caption: t('syncflow:cut_off_time'), width:200, 
                        cellRender:grid_render.cuttoff_cell_render},
                    { dataField: "orderPeriod", caption: "Period", width:150, required: true,requiredMessage: t("period_is_required"),
                               lookup: {dataSource: periods,valueExpr: "id",displayExpr: "description"}
                    },
                  
                     { dataField: 'summary',caption: t('syncflow:order_days'),
                         cellRender: (data: any) => {
                             const period = data?.data?.orderPeriod;
                             if (period === 'W') return grid_render.order_day_cell_render(data);
                             if (period === 'M') return grid_render.order_monthly_cell_render(data);
                             return null;
                         }
                     },  
                    { dataField: 'weekPeriod', caption: t('syncflow:week_period'),allowEditing: false,visible:false },                 
                    { dataField: 'hasAdditionalOrder', caption: t('syncflow:has_additional_order'),allowEditing: true},
                    { dataField: 'cannotOrderAfterCutOffTime', caption: t('syncflow:cut_off_after_is_order'),allowEditing: true},
                    { dataField: 'isOrderDay01',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'isOrderDay02',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'isOrderDay03',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'isOrderDay04',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'isOrderDay05',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'isOrderDay06',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'isOrderDay07',  caption: t('syncflow:order_days'),allowEditing: false,visible:false},
                    { dataField: 'deliveryDay01', caption: t('syncflow:delivery_01'),allowEditing: false,visible:false },
                    { dataField: 'deliveryDay02', caption: t('syncflow:delivery_02'),allowEditing: false,visible:false },
                    { dataField: 'deliveryDay03', caption: t('syncflow:delivery_03'),allowEditing: false,visible:false },
                    { dataField: 'deliveryDay04', caption: t('syncflow:delivery_04'),allowEditing: false,visible:false },
                    { dataField: 'deliveryDay05', caption: t('syncflow:delivery_05'),allowEditing: false,visible:false },
                    { dataField: 'deliveryDay06', caption: t('syncflow:delivery_06'),allowEditing: false,visible:false },
                    { dataField: 'deliveryDay07', caption: t('syncflow:delivery_07'),allowEditing: false,visible:false },
                    { dataField: 'firstWeek', caption: t('syncflow:delivery_07'),allowEditing: false,visible:false },
                    { dataField: 'secondWeek', caption: t('syncflow:delivery_07'),allowEditing: false,visible:false },
                    { dataField: 'thirdWeek', caption: t('syncflow:delivery_07'),allowEditing: false,visible:false },
                    { dataField: 'fourthWeek', caption: t('syncflow:delivery_07'),allowEditing: false,visible:false },
                    { dataField: 'lastWeek', caption: t('syncflow:delivery_07'),allowEditing: false,visible:false },
                   
                ]}
            />
        </>
    )
}
export default vendorSupplyParameter